import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { HSM_REPORT_ROUTES as ROUTES } from 'constants/index'

import { BarChart, Check } from '@mui/icons-material'
import { List, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material'

const routesMap = [
  {
    path: ROUTES.REPORT,
    icon: <BarChart />,
    title: 'Volume de disparos ativos',
  },

  {
    path: ROUTES.MONITORING_NUMBERS,
    icon: <Check />,
    title: 'Monitoramento de números',
  },
]

function Hsm() {
  const location = useLocation()
  const pathnameWithoutSlash = location.pathname.split('/')
  const routePath = pathnameWithoutSlash[pathnameWithoutSlash.length - 1]
  const locationPath = routePath === ROUTES.REPORT ? 'Volume de disparos ativos' : 'Monitoramento de números'

  return (
    <Stack direction="row" width="100%" height="100dvh">
      <Stack component="nav" mt="1rem" sx={{ width: '15%', padding: '0 0.5rem' }}>
        <List dense>
          {routesMap.map((route) => (
            <ListItemButton key={route.path} component={NavLink} to={route.path} selected={routePath === route.path}>
              <ListItemIcon sx={{ color: routePath === route.path ? '#00AEEF' : null }}>{route.icon}</ListItemIcon>
              <ListItemText>{route.title}</ListItemText>
            </ListItemButton>
          ))}
        </List>
      </Stack>
      <Stack direction="column" mt="1rem" sx={{ width: '85%' }}>
        <Stack direction="row" padding="0.5rem">
          <Typography sx={{ color: 'text.secondary' }}>{'Relatórios / Geral / '}</Typography>
          <Typography sx={{ color: 'text.secondary', ml: '0.3rem', fontWeight: 'bold' }}>{locationPath}</Typography>
        </Stack>
        <Stack mt="1rem" p="0.5rem" sx={{ height: '100%', overflowY: 'auto' }}>
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}
export default Hsm
